import { TPlayerState } from '@/redux/reducers/player';
import { TGetPlayersInClassSuccess } from '@/redux/actions/player';

export const getPlayersInClassUpdateState = (state: TPlayerState, action: TGetPlayersInClassSuccess): TPlayerState => ({
  ...state,
  getPlayersInClassResponse: action.payload.response,
});
